"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var Styled_1 = require("./Styled");

var Grid_1 = __importDefault(require("../../Grid"));

var TextStyle_1 = __importDefault(require("../../TextStyle"));
/**
 * Label component is meant to wrap Input components.
 *
 * Some props are shared, such as:
 * * id with the same value as the label name
 * @version 1.0.0
 */


var Label =
/** @class */
function (_super) {
  __extends(Label, _super);

  function Label() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderLabel = function () {
      var _a = _this.props,
          label = _a.label,
          action = _a.action;

      if (action !== undefined) {
        return react_1.default.createElement(Grid_1.default.Container, {
          cols: 2
        }, react_1.default.createElement(Grid_1.default.Cell, null, react_1.default.createElement(TextStyle_1.default, {
          weight: "bold",
          size: "small"
        }, label)), react_1.default.createElement(Grid_1.default.Cell, {
          placeSelf: "end"
        }, action));
      }

      return react_1.default.createElement(TextStyle_1.default, {
        weight: "bold",
        size: "small"
      }, label);
    };

    return _this;
  }

  Label.prototype.render = function () {
    var _a = this.props,
        name = _a.name,
        children = _a.children; // @ts-ignore

    var input = react_1.default.cloneElement(children, {
      id: name
    });
    return react_1.default.createElement(Styled_1.Label, {
      htmlFor: name
    }, this.renderLabel(), input);
  };

  return Label;
}(react_1.PureComponent);

exports.default = Label;